import { createStyles, makeStyles } from "@material-ui/core";
import React, { useState } from "react";
import { OrderTypesCollection } from "../../formSchemas/ordersSetting.form";
import { IYoelloTheme } from "../../yoello-lib/modules/themes/IYoelloTheme";
import { CollectionTabs, ITabs } from "./types.d";
import { FormsContainer } from "./Forms/FormsContainer"
import { TopTabs } from "./Ui/TopTabs";
import { PickupContainer } from "./Forms/PickupContainer";
import { useSelector } from "react-redux";
import { IReduxAppState } from "../../reducers";
import IVenueSettings from "../../interfaces/IVenueSettings";
import { CollectionAlert } from "./Ui/CollectionAlert";
import useCheckPermissions from "../../hooks/useCheckPermissions";
import { PERMISSIONS } from "../../const/permissions.const";
import DisabledActionWrapper from "../../yoello-lib/modules/components/DisabledActionWrapper";

const useStyles = makeStyles((theme: IYoelloTheme) =>
    createStyles({
        root: {
            display: "flex",

        },
        tabs: {
            display: "flex",
            flexDirection: "row",
            paddingBottom: "1.25rem"
        }
    }),
);
const collectionTabs: ITabs = {
    direction: "row",
    tabs: [
        {
            key: CollectionTabs.COLLECTION,
            title: "forms.orders.ordersSettingTabs.collectionTab"
        },
        {
            key: CollectionTabs.PICKUP,
            title: "forms.orders.ordersSettingTabs.pickup"
        }
    ]
}

const noQuickPickupPartners = ["DELIVERECT", "NCR", "ORACLE", "ZONAL", "TEVALIS"]
interface ICollectionContainerProps {
    onFormSubmit: (data: any) => Promise<void>;
}
const YOELLO = "YOELLO";
export function CollectionContainer({
    onFormSubmit,
}: ICollectionContainerProps) {
    const { tabs } = useStyles();
    const selectedVenueId = useSelector((state: IReduxAppState) => state.selectedVenueId)
    const settings = useSelector((state: IReduxAppState) => state.venue[selectedVenueId].venueSettings)
    const onboardingSource = useSelector((state: IReduxAppState) => state.venue[selectedVenueId].venueData?.onboarding_source)
    const subscription = useSelector((state: IReduxAppState) => state.subscription)

    const { hasPermission, onFailedInteraction } = useCheckPermissions(PERMISSIONS.ORDER_SETTINGS_MANAGEMENT);

    const [collectionTab, setCollectionTab] = useState(settings?.pickup_now_enabled ? CollectionTabs.PICKUP : CollectionTabs.COLLECTION);

    function onChangeTab(tab: string) {
        setCollectionTab(tab as CollectionTabs);
    }

    function renderItems() {
        if (collectionTab === CollectionTabs.PICKUP && subscription === YOELLO && !noQuickPickupPartners.includes(onboardingSource ?? '')) {
            return <PickupContainer />;
        }
        return <DisabledActionWrapper
            disabled={!hasPermission}
            onDisabledClick={onFailedInteraction}
        >
            <CollectionWraper
                settings={settings!}
                onFormSubmit={onFormSubmit}
                isDisabled={!hasPermission}
                onFailedInteraction={onFailedInteraction}
            />
        </DisabledActionWrapper>

    }

    return <div>
        {subscription === YOELLO && !noQuickPickupPartners.includes(onboardingSource ?? '') &&  <div className={tabs}>
            <TopTabs {...collectionTabs} selected={collectionTab} onChange={onChangeTab} />
        </div>}
        {renderItems()}
    </div>
}
interface ICollectionWrapper extends ICollectionContainerProps {
    settings: IVenueSettings;
    isDisabled?: boolean;
    onFailedInteraction?: Function;
}
function CollectionWraper({
    onFormSubmit,
    settings,
    isDisabled,
    onFailedInteraction

}: ICollectionWrapper) {
    return <div>
        <CollectionAlert isDisabled={settings?.pickup_now_enabled === true} label="pickupEnabled" />
        <FormsContainer
            profileForms={OrderTypesCollection(settings?.pickup_now_enabled!)}
            onFormSubmit={onFormSubmit}
            settings={settings}
            formKey="collection"
            isDisabled={isDisabled}
            onFailedInteraction={onFailedInteraction}
        />
    </div>
}